import { LinkIcon, MapPinIcon, CalendarDaysIcon } from "@heroicons/react/24/outline";
import PageWrapper from "../component/sharedComponents/PageWrapper";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../assets/images/Avatar.avif"
import PostsBase from "../component/sharedComponents/PostsBase";
import { getUserByCode } from "../slices/3-Users/thunk";

const AnotherProfilePage = () => {
    const { code } = useParams();
    const { i18n, t } = useTranslation();
    const { selectedUser } = useSelector((state) => state.users);
    const dispatch = useDispatch()
    // const navigate = useNavigate();
    useEffect(() => {
        dispatch(getUserByCode(code));
    }, [dispatch]);


    const formatJoinedDate = (isoDate, locale = "en") => {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        return new Intl.DateTimeFormat(locale, { month: "long", year: "numeric" }).format(date);
    };


    // console.log(selectedUser)
    return (
        <PageWrapper>
            <div className="overflow-hidden ">

                {/* COVER */}
                <div className="relative w-full h-52">
                    {selectedUser?.coverImage ?
                        <img
                            src={selectedUser?.coverImage}
                            className="object-cover w-full h-full"
                            alt="cover"
                        />
                        : <div className="w-full h-44 dark:bg-bg-dark-tertiary bg-bg-light-tertiary lg:h-52">
                        </div>
                    }

                    {/* AVATAR */}
                    <img
                        src={selectedUser?.avatar || avatar}
                        alt="avatar"
                        className="absolute border-2 rounded-full h-28 w-28 lg:h-32 lg:w-32 lg:-bottom-16 -bottom-8 start-4 border-primary-light dark:border-primary"
                    />
                </div>

                {/* PROFILE INFO */}
                <div className="flex flex-col gap-6 px-4 pt-10 lg:pt-20 md:flex-row md:justify-between">

                    {/* LEFT INFO */}
                    <div>
                        <h1 className="text-2xl font-bold text-black dark:text-white">
                            {selectedUser?.fullName}
                        </h1>
                        <p className="text-sm text-text-muted-light dark:text-text-muted-dark">
                            @{selectedUser?.code}
                        </p>

                        {/* BIO */}
                        <p className="max-w-xl mt-3 text-sm text-gray-700 dark:text-gray-300">
                            {selectedUser?.bio}
                        </p>

                        {/* META */}
                        <div className="flex flex-wrap gap-5 mt-4 text-sm text-text-muted-light dark:text-text-muted-dark">

                            {selectedUser?.location && (
                                <div className="flex items-center gap-1">
                                    <MapPinIcon className="w-4 h-4" />
                                    <span>{selectedUser?.location}</span>
                                </div>
                            )}

                            {selectedUser?.website && (
                                <div className="flex items-center gap-1 dark:text-primary text-primary-light">
                                    <LinkIcon className="w-4 h-4" />
                                    <a href="/#" className="hover:underline">
                                        {selectedUser?.website}
                                    </a>
                                </div>
                            )}

                            <div className="flex items-center gap-1">
                                <CalendarDaysIcon className="w-4 h-4" />
                                {t("profile.joined")} {formatJoinedDate(selectedUser?.createdAt, i18n.language)}
                            </div>
                        </div>

                        {/* FOLLOW */}
                        {(selectedUser?.following || selectedUser?.followers) &&
                            <div className="flex gap-6 mt-4">
                                <div>
                                    <span className="font-semibold text-black dark:text-white">
                                        {selectedUser?.following}
                                    </span>{" "}
                                    <span className="text-text-muted-light dark:text-text-muted-dark">{t("profile.following")}</span>
                                </div>
                                <div>
                                    <span className="font-semibold text-black dark:text-white">
                                        {selectedUser?.followers}
                                    </span>{" "}
                                    <span className="text-text-muted-light dark:text-text-muted-dark">{t("profile.followers")}</span>
                                </div>
                            </div>
                        }
                    </div>

                    {/* RIGHT BUTTON */}
                    {/* <div className="flex items-start gap-4">

                        <MainButton
                        >
                            {t("profile.follow")}
                        </MainButton>
                        <button
                            className="px-3 py-2 text-sm transition-colors border rounded-xl border-border-light dark:border-border-dark hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
                        >
                            <EllipsisHorizontalIcon className="w-6 h-6 text-gray-500" />
                        </button>
                    </div> */}
                </div>

                {/* TABS */}
                <div className="w-full mt-8 border-b border-border-light dark:border-border-dark">

                </div>

                {/* TAB CONTENT */}
                <div className="mt-6">
                    <PostsBase posts={selectedUser?.Posts} />
                </div>
            </div>
        </PageWrapper>
    );
};

export default AnotherProfilePage;
